import { cva } from '@/styled-system/css';

export const toggleCardFooterRecipe = cva({
  base: {
    marginBlockStart: 'loose',
  },
  variants: {
    divider: {
      true: {
        paddingBlockStart: 'default',
        borderBlockStartWidth: 'default',
        borderBlockStartStyle: 'solid',
        borderBlockStartColor: 'ToggleCard.Footer.border',
      },
      false: {},
    },
  },
});
